// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ll-0";
export var fileList = "_ll-2";
export var removeFileButton = "_ll-1";